// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__14mqN","container":"style_container__1ZPsI","time":"style_time__wX0Vo"};